import {EnkelGruppeModell, Gruppetype, MedlemsRolleModell, TilgangsrolleMedlem} from "../tjenester/ressurser/generertNg2HttpKlient";
import {Brukerkontekst} from "felles-ng2/tjenester/Brukerkontekst";

export function gruppelogoSti(gruppeId: string, logoId: string, bredde = 40): string {
    return `/api/gruppe/${gruppeId}/logo/${logoId}?format=png&bredde=${bredde}`;
}

/** Returnerer aksjeeier-rolle, dersom slik finnes */
export function finnAksjeeierRolle(roller: MedlemsRolleModell[]): MedlemsRolleModell | null {
    //@todo hvilke navn skal vi teste mot?
    const aksjeeierRoller = ['aksjonær', 'aksjeeier'];
    return roller
      .find(rolle => aksjeeierRoller.includes(rolle.tittel.toLowerCase())) ?? null;
}

export function alleGrupperMedType<E extends EnkelGruppeModell>(grupper: E[], type: Gruppetype): E[] {
    return grupper.filter(gruppe => gruppe.gruppetype == type);
}

/** Returnerer gruppene bruker har skrivetilgang til */
export function grupperDerBrukerHarTilgangsrolle<E extends EnkelGruppeModell>(grupper: E[], bruker: Brukerkontekst, tilgangsrolleMedlem: TilgangsrolleMedlem): E[] {
    return grupper.filter(gruppe => bruker.inneharTilgangsrolleIGruppe(tilgangsrolleMedlem, gruppe.id));
}

/** Sorterer gruppe på organisasjonsnavn så tittel.
 * Speiler no.systemfabrikken.lederplan.domene.gruppe.Gruppe#compareTo */
export function sorterGrupperPåOrganisasjonSåTittel(a: EnkelGruppeModell, b: EnkelGruppeModell): number {
    let resultat = a.organisasjonsnavn.toLocaleLowerCase().localeCompare(b.organisasjonsnavn.toLocaleLowerCase());
    if (resultat != 0) return resultat;
    resultat = a.tittel.toLocaleLowerCase().localeCompare(b.tittel.toLocaleLowerCase());
    if (resultat != 0) return resultat;
    return a.id.localeCompare(b.id);
}

/** Grupperer angitte grupper etter organisasjonsnavn.
 * Casing i avtalenavn ignoreres ved gruppering. */
export function grupperGruppertPåOrganisasjonsnavn(grupper: EnkelGruppeModell[]): Map<string, EnkelGruppeModell[]> {
    //grupper etter organisasjonsnavn, caseinsensitivt
    const orgMedGrp = grupper
      .reduce((orgMedGrp, gruppe) => {
          const orgnavn = gruppe.organisasjonsnavn.toLowerCase();
          if (!orgMedGrp.has(orgnavn)) orgMedGrp.set(orgnavn, [])
          orgMedGrp.get(orgnavn)!.push(gruppe);
          return orgMedGrp;
      }, new Map<string, EnkelGruppeModell[]>());

    //returner ny map der casing på organisasjonsnavn ikke er endret
    return [...orgMedGrp.values()]
      .reduce((orgMedGrp, grupper) =>
          orgMedGrp.set(grupper[0].organisasjonsnavn, grupper),
        new Map<string, EnkelGruppeModell[]>());
}
